import React from 'react';
import useLanguage from '../../../../hooks/useLanguage';
import { ThemeContext } from '../../../../context/ThemeProvider';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import PropTypes from 'prop-types';

const PackagesModalContent = ({
  defaultPrice,
  salePrice,
  open,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phone,
  setPhone,
  mail,
  setMail,
  promoHandler,
  price,
  payHandler,
  debounce,
}) => {
  const langToggle = useLanguage;
  const { themeMode } = React.useContext(ThemeContext);

  const changeFirstName = (e) => {
    setFirstName(e.target.value)
    payHandler()
  }

  const changeLastName = (e) => {
    setLastName(e.target.value)
    payHandler()
  }

  const changeMail = (e) => {
    setMail(e.target.value)
    payHandler()
  }

  // const changePhone = () => {
  //   setPhone()
  //   payHandler()
  // }

  return (
    <div className="packages-modal__content">
      <div
        className={open ? 'form-input__wrapper is-open' : 'form-input__wrapper'}
      >
        <label className="form-label">{langToggle("Ім'я:", 'Имя:')}</label>
        <input
          type="text"
          name="sender_first_name"
          placeholder={langToggle("Введіть ваше ім'я ", 'Введите ваше имя')}
          value={firstName}
          onChange={changeFirstName}
          required
        />
      </div>
      <div
        className={open ? 'form-input__wrapper is-open' : 'form-input__wrapper'}
      >
        <label className="form-label">{langToggle('Призвіще:', 'Фамилия:')}</label>
        <input
          type="text"
          name="sender_last_name"
          placeholder={langToggle(
            'Введіть ваше призвіще',
            'Введите вашу фамилию'
          )}
          value={lastName}
          onChange={changeLastName}
          required
        />
      </div>
      <div
        className={
          open
            ? 'form-input__wrapper form-input__wrapper-phone is-open'
            : 'form-input__wrapper'
        }
      >
        <label className="form-label">
          {langToggle('Телефон:', 'Телефон:')}
        </label>
        <PhoneInput
          country={'ua'}
          name="phone"
          className="phone"
          value={phone}
          onChange={setPhone}
          required
        />
      </div>
      <div
        className={open ? 'form-input__wrapper is-open' : 'form-input__wrapper'}
      >
        <label className="form-label">{langToggle('e-mail:', 'e-mail:')}</label>
        <input
          type="email"
          name="mail"
          placeholder={langToggle('Введіть ваш e-mail', 'Введите ваш e-mail:')}
          value={mail}
          onChange={changeMail}
          required
        />
      </div>
      <div
        className={open ? 'form-input__wrapper is-open' : 'form-input__wrapper'}
      >
        <label className="form-label">
          {langToggle('Промокод:', 'Промокод:')}
        </label>
        <input
          type="text"
          placeholder={langToggle(
            'Введіть ваш промокод',
            'Введите ваш Промокод'
          )}
          onChange={promoHandler}
        />
      </div>
      <div
        className={open ? 'form-input__wrapper is-open' : 'form-input__wrapper'}
      >
        <span className="form-price">
          <span className="form-price__count">
            {price === false ? defaultPrice : salePrice}
          </span>
          <span className="form-price__currency">{themeMode}</span>
        </span>
      </div>
    </div>
  );
};

PackagesModalContent.propTypes = {
  selected: PropTypes.object,
  promoCode: PropTypes.array,
  open: PropTypes.bool,
  firstName: PropTypes.string,
  setFirstName: PropTypes.func,
  lastName: PropTypes.string,
  setLastName: PropTypes.func,
  phone: PropTypes.string,
  setPhone: PropTypes.func,
  mail: PropTypes.string,
  setMail: PropTypes.func,
  promoHandler: PropTypes.func,
  price: PropTypes.bool,
};

export default PackagesModalContent;
